export default __webpack_public_path__ + "static/media/article.bd5522c3.png";